var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicineBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19577_32812)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19577_32812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 334,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 74,
    fill: "#EEFAFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19577_32812)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -6,
    cy: 111,
    r: 113,
    fill: "#002686",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -6,
    cy: 111,
    r: 101.9,
    stroke: "url(#paint1_linear_19577_32812)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 111C86 161.81 44.8102 203 -6 203C-56.8102 203 -98 161.81 -98 111C-98 60.1898 -56.8102 19 -6 19C44.8102 19 86 60.1898 86 111Z",
    fill: "#002686",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9 111C85.9 161.755 44.755 202.9 -6 202.9C-56.755 202.9 -97.9 161.755 -97.9 111C-97.9 60.245 -56.755 19.1 -6 19.1C44.755 19.1 85.9 60.245 85.9 111Z",
    stroke: "url(#paint2_linear_19577_32812)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 111C76 156.287 39.2874 193 -6 193C-51.2873 193 -88 156.287 -88 111C-88 65.7127 -51.2873 29 -6 29C39.2874 29 76 65.7127 76 111Z",
    fill: "#002686",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 111C75.9 156.232 39.2321 192.9 -6 192.9C-51.2321 192.9 -87.9 156.232 -87.9 111C-87.9 65.7679 -51.2321 29.1 -6 29.1C39.2321 29.1 75.9 65.7679 75.9 111Z",
    stroke: "url(#paint3_linear_19577_32812)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 111C65 150.212 33.2122 182 -6 182C-45.2122 182 -77 150.212 -77 111C-77 71.7878 -45.2122 40 -6 40C33.2122 40 65 71.7878 65 111Z",
    fill: "#002686",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 111C64.9 150.157 33.157 181.9 -6 181.9C-45.157 181.9 -76.9 150.157 -76.9 111C-76.9 71.843 -45.157 40.1 -6 40.1C33.157 40.1 64.9 71.843 64.9 111Z",
    stroke: "url(#paint4_linear_19577_32812)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 111C55 144.689 27.6894 172 -6 172C-39.6894 172 -67 144.689 -67 111C-67 77.3106 -39.6894 50 -6 50C27.6894 50 55 77.3106 55 111Z",
    fill: "#002686",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9 111C54.9 144.634 27.6341 171.9 -6 171.9C-39.6341 171.9 -66.9 144.634 -66.9 111C-66.9 77.3659 -39.6341 50.1 -6 50.1C27.6341 50.1 54.9 77.3659 54.9 111Z",
    stroke: "url(#paint5_linear_19577_32812)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 111C45 139.167 22.1665 162 -6 162C-34.1665 162 -57 139.167 -57 111C-57 82.8335 -34.1665 60 -6 60C22.1665 60 45 82.8335 45 111Z",
    fill: "#002686",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9 111C44.9 139.111 22.1113 161.9 -6 161.9C-34.1113 161.9 -56.9 139.111 -56.9 111C-56.9 82.8887 -34.1113 60.1 -6 60.1C22.1113 60.1 44.9 82.8887 44.9 111Z",
    stroke: "url(#paint6_linear_19577_32812)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.5 55.1277C175.704 46.5692 165.75 30.5716 165.75 12.25C165.75 -15.0881 187.912 -37.25 215.25 -37.25C233.572 -37.25 249.569 -27.2956 258.128 -12.5",
    stroke: "#8369DA",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.75,
    cy: 61.75,
    r: 49.5,
    stroke: "#8369DA",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25 78.25L285.375 49.375",
    stroke: "#8369DA",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32812",
    x1: -9.9296e-7,
    y1: 31.7143,
    x2: 294.149,
    y2: 141.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19577_32812",
    x1: 83.5,
    y1: 171,
    x2: -58,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19577_32812",
    x1: 74.7255,
    y1: 165.118,
    x2: -52.902,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19577_32812",
    x1: 65.951,
    y1: 159.235,
    x2: -47.8039,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19577_32812",
    x1: 56.299,
    y1: 152.765,
    x2: -42.1961,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19577_32812",
    x1: 47.5245,
    y1: 146.882,
    x2: -37.098,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19577_32812",
    x1: 38.75,
    y1: 141,
    x2: -32,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineBackground);
export default __webpack_public_path__ + "static/media/MedicineBackground.fc017dd7d7c559771749de3854af3779.svg";
export { ForwardRef as ReactComponent };